module.exports = __webpack_public_path__ + "img/南宁万象.6244c056.png";